/**
 * Pump Command Center — grouped sidebar navigation.
 */
import { PUMP_HUB_NAV } from './adminPumpHubConfig';

export default function AdminPumpHubSidebar({ activeModule, onSelectModule }) {
  return (
    <nav className="admin-pump-hub__sidebar" aria-label="Pump hub modules">
      {PUMP_HUB_NAV.map((group) => (
        <div className="admin-pump-hub__nav-group" key={group.group}>
          <div className="admin-pump-hub__nav-group-label">{group.group}</div>
          {group.items.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`admin-pump-hub__nav-item ${activeModule === item.id ? 'is-active' : ''}`}
              onClick={() => onSelectModule(item.id)}
            >
              <span className="admin-pump-hub__nav-item-title">{item.label}</span>
              <span className="admin-pump-hub__nav-item-desc">{item.description}</span>
            </button>
          ))}
        </div>
      ))}
    </nav>
  );
}
